import { trigger, transition, style, animate } from '@angular/animations';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnInit,
  AfterViewInit,
} from '@angular/core';

@Component({
    selector: 'canvas-overlay-panel',
    templateUrl: './overlay-panel.component.html',
    styleUrls: ['./overlay-panel.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX(100%)' }),
                animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateX(100%)' })),
            ]),
        ]),
    ],
    standalone: false
})
export class OverlayPanelComponent implements AfterViewInit {
  @Input() Type: 'right' | 'left' | 'top' | 'bottom' | 'dialog' = 'right';

  @Input() Context?: unknown;
  @Output() BackdropPressed: EventEmitter<unknown | undefined> =
    new EventEmitter();
  @Input() AutoScroll = false;
  private LastScrollHeight = 0;
  private LastScrollAmount = 0;
  private MinScrollHeight  = 100;
  private Height = 0;
  private interval!: any;
  @ViewChild('panel') el!: ElementRef;

  ngAfterViewInit(): void {
    this.interval = setInterval(() => {
      this.RunScrollDown();
    }, 1000);
    this.RunScrollDown();
  }

  public RunScrollDown() {
    const element = this.el.nativeElement;

    if(this.Height < element.scrollHeight){
      element.scrollBy(0, this.MinScrollHeight);
    }else{
      clearInterval(this.interval);
    }

    this.Height += this.MinScrollHeight;
  }
}
